import React, { Component } from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as wActs from "../actions/website-actions";

class HtmlSection extends Component {

  constructor(props) {
    super(props);
  }


  render() {
    if(typeof this.props.HtmlSections[this.props.Id] !== "undefined") {
      if(this.props.UseDiv) {
        return (
          <div dangerouslySetInnerHTML={{
            __html: this.props.HtmlSections[this.props.Id]
          }}>
         </div>
        );
      } else {
        return (
          <span style={{margin: "0px", padding: "0px", border: "none", display: "inline"}} dangerouslySetInnerHTML={{
            __html: this.props.HtmlSections[this.props.Id]
          }}>
         </span>
        );
      }
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    HtmlSections: state.Website.Settings.HtmlSections
  }
}

export default connect(mapStateToProps)(HtmlSection);
